import { render, staticRenderFns } from "./PolicyContainers.vue?vue&type=template&id=cbcb0a38&scoped=true"
import script from "./PolicyContainers.vue?vue&type=script&lang=js"
export * from "./PolicyContainers.vue?vue&type=script&lang=js"
import style0 from "./PolicyContainers.vue?vue&type=style&index=0&id=cbcb0a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcb0a38",
  null
  
)

export default component.exports